class McStoreNavigation extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        document.documentElement.style.setProperty('--store-navigation-bar-height', `${this?.offsetHeight || 0}px`);

        this.storeArea = this.querySelector("[data-select-area]");
        this.subMenus = this.querySelectorAll("[data-submenu]");

        if (this.storeArea?.options?.length ) {
            this.selectedArea = this.storeArea.options[this.storeArea.selectedIndex]?.dataset.area || "";
            this.updateSubMenu(this.selectedArea);

            this.storeArea.addEventListener("change", () => {
                const selectedOption = this.storeArea.options[this.storeArea.selectedIndex];
                const newSelectedArea = selectedOption?.dataset.area || "";
                this.updateSubMenu(newSelectedArea);
                window.location.href = this.storeArea.value;
            });
        }

        this.updateSubLinks();
        this.addEventListeners();
    }

    updateSubLinks() {
        const subLinks = this.querySelectorAll("[data-sublink]");

        const urlHash = window.location.hash
        if (!urlHash) return

        subLinks.forEach(subLink => {
            const subLinkHref = subLink.getAttribute("href");
            subLink.setAttribute("data-active", subLinkHref.includes(urlHash));
        });
    }

    addEventListeners() {
        this.querySelectorAll("[data-sublink]").forEach(subLink => {
            subLink.addEventListener("click", () => {
                this.updateSubLinks();
            });
        });

        window.addEventListener("hashchange", () => this.updateSubLinks());
    }

    updateSubMenu(selectedArea) {
        this.subMenus.forEach(subMenu => {
                subMenu.setAttribute("data-visible", subMenu.getAttribute("data-area") === selectedArea );
        });
    }
}

customElements.define("store-navigation", McStoreNavigation);
